import { useMemo } from 'react'

import { queryAnnouncementPageApi } from '@eastcoal/api/trade/announcementMall/queryAnnouncementPage'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AnnouncementType } from '@eastcoal/shared/enums/AnnouncementType'

import { APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH } from '../../pages/Content/Announcement/Apply/constants/path'
import { TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH } from '../../pages/Content/Announcement/Transaction/constants/path'
import { ListTitleLink } from '../ListTitleLink'

import { AnnouncementListProps, AnnouncementListTableProps } from './interface'

const AnnouncementTypePathMap = {
  [AnnouncementType.APPLY]: APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH,
  [AnnouncementType.TRANSACTION]: TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH
}

export const AnnouncementList = ({
  type,
  kindCodes,
  defaultPageSize,
  titleMaxWidth
}: AnnouncementListProps) => {
  const columns: AnnouncementListTableProps['columns'] = useMemo(
    () => [
      {
        dataIndex: 'title',
        render(_, { id, title, type = AnnouncementType.APPLY }) {
          return (
            <ListTitleLink
              maxWidth={titleMaxWidth}
              to={stringifyUrl({
                url: AnnouncementTypePathMap[type],
                query: { id }
              })}
            >
              {title}
            </ListTitleLink>
          )
        }
      },
      {
        dataIndex: 'publishTime',
        width: 140,
        align: 'right',
        valueType: {
          type: 'text',
          secondary: true
        }
      }
    ],
    [titleMaxWidth]
  )

  return (
    <RemoteTable
      api={queryAnnouncementPageApi}
      bordered={false}
      columns={columns}
      defaultPageSize={defaultPageSize}
      pagination={false}
      rowKey='id'
      showHeader={false}
      requestParams={{
        type,
        kindCodes,
        status: 1,
        orders: [
          {
            column: 'publish_time',
            asc: false
          }
        ]
      }}
    />
  )
}
